import { Target, Network, Share2 } from "lucide-react";
import { Reveal, StaggerGroup, StaggerItem } from "./Reveal";
import { useI18n } from "../i18n/LanguageContext";

const CARD_META = [
  { icon: Target, img: "https://images.unsplash.com/photo-1771599940657-f9f151abed45" },
  { icon: Network, img: "https://images.unsplash.com/photo-1709626011485-6fe000ea2dbc" },
  { icon: Share2, img: null },
];

export const CognitiveSearchPanel = () => {
  const { t } = useI18n();
  const cards = t("panel.cards");
  return (
    <section id="search-panel" className="relative py-28 md:py-36 px-6">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <p className="font-mono text-[13px] tracking-[0.3em] uppercase text-[#4BE3FF] mb-5">
            {t("panel.kicker")}
          </p>
          <h2 className="font-display font-bold tracking-tight text-4xl md:text-5xl lg:text-6xl max-w-3xl leading-[1.02]">
            {t("panel.titleA")}
            <span className="text-[#A7B4C2]">{t("panel.titleB")}</span>
          </h2>
        </Reveal>

        <StaggerGroup className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
          {CARD_META.map((meta, i) => {
            const Icon = meta.icon;
            const c = cards[i];
            return (
              <StaggerItem key={c.title}>
                <div
                  data-testid={`concept-card-${i}`}
                  className="group relative h-full min-h-[380px] rounded-2xl border border-[#A7B4C2]/15 bg-[#05101f]/60 p-8 overflow-hidden transition-colors duration-500 hover:border-[#4BE3FF]/40"
                >
                  {meta.img && (
                    <div className="absolute inset-0 opacity-20 group-hover:opacity-30 transition-opacity duration-700">
                      <img
                        src={meta.img}
                        alt=""
                        className="w-full h-full object-cover [mask-image:linear-gradient(to_top,#000,transparent_80%)]"
                      />
                    </div>
                  )}
                  <div className="absolute -inset-px opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none rounded-2xl [box-shadow:0_0_60px_-12px_rgba(75,227,255,0.4)_inset]" />

                  <div className="relative z-10 flex flex-col h-full">
                    <div className="flex items-center justify-center w-14 h-14 rounded-xl border border-[#4BE3FF]/30 bg-[#0A1A2F] text-[#4BE3FF] group-hover:scale-110 group-hover:cyan-glow transition-all duration-500">
                      <Icon className="w-6 h-6" />
                    </div>
                    <p className="font-mono text-[12px] tracking-widest uppercase text-[#A7B4C2]/70 mt-8">
                      {c.tag}
                    </p>
                    <h3 className="font-display font-semibold text-2xl mt-2 text-white">
                      {c.title}
                    </h3>
                    <p className="font-ui text-[15px] text-[#A7B4C2] mt-4 leading-relaxed">
                      {c.desc}
                    </p>
                    <div className="mt-auto pt-6 h-px w-full bg-gradient-to-r from-[#1E6FFF] via-[#4BE3FF]/40 to-transparent group-hover:from-[#4BE3FF] transition-colors duration-500" />
                  </div>
                </div>
              </StaggerItem>
            );
          })}
        </StaggerGroup>
      </div>
    </section>
  );
};
